import {GST} from './GST';

export class FinzyFee {
    public gst: GST;
    public amount: number;

    constructor();
    constructor(amount: number, gst: GST);
    constructor(amount?: number, gst?: GST) {
        this.amount = amount;
        this.gst = gst;
    }

    public static from(json: any): FinzyFee {
        if (!json) {
            return json;
        }
        return new FinzyFee(json.amount, GST.from(json.gst));
    }

    public total(): number {
        return this.amount + this.gst.total();
    }
}